import { useState } from "react";
import { PIPELINES } from "./constants";
import { S, Ic, Dropdown, focusIn, focusOut } from "./ui";

// ═══════════════════════════════════════════════════════════
// CRM HEADER
// ═══════════════════════════════════════════════════════════
export default function CrmHeader({
  view, setView,
  activeTab, setActiveTab,
  onCreateNew,
  total,
  pipeline, setPipeline,
}) {
  const [intOpen, setIntOpen] = useState(false);

  const listTabs = [
    { code: "active",   label: "Active" },
    { code: "archived", label: "Archived" },
    { code: "all",      label: "All Opportunities" },
  ];

  const BtnTab = ({ code, label }) => (
    <button
      onClick={() => setActiveTab(code)}
      style={{
        height: "38px", padding: "0 16px", border: "none", background: "transparent",
        borderBottom: activeTab === code ? "2px solid #0f3460" : "2px solid transparent",
        cursor: "pointer", fontSize: "12.5px",
        fontWeight: activeTab === code ? "600" : "400",
        color: activeTab === code ? "#1a1a2e" : "#8888a8",
        transition: "all .15s", whiteSpace: "nowrap",
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ background: "#fff", borderBottom: "1px solid #eaeaed", position: "sticky", top: 0, zIndex: 200 }}>

      {/* ── Row 1: Main Controls ── */}
      <div style={{ ...S.row(10), padding: "0 20px", height: "52px", justifyContent: "space-between" }}>

        {/* LEFT */}
        <div style={S.row(10)}>
          {/* Logo */}
          <div style={S.row(6)}>
            <div style={{
              width: "28px", height: "28px", flexShrink: 0,
              background: "linear-gradient(135deg,#1a1a2e,#0f3460)",
              borderRadius: "7px", display: "flex", alignItems: "center",
              justifyContent: "center", color: "#fff", fontSize: "10.5px",
              fontWeight: "800", letterSpacing: "-0.3px",
            }}>CO</div>
            <span style={{ fontSize: "14.5px", fontWeight: "700", color: "#1a1a2e", letterSpacing: "-0.2px" }}>CORE</span>
          </div>

          <div style={{ width: "1px", height: "18px", background: "#e0e0e8", flexShrink: 0 }} />

          {/* Title + count */}
          <span style={{ fontSize: "14px", fontWeight: "700", color: "#1a1a2e", whiteSpace: "nowrap" }}>
            Opportunities
            <span style={{
              marginLeft: "6px", background: "#f0f0f8", color: "#7878a0",
              borderRadius: "20px", padding: "1px 8px", fontSize: "11.5px", fontWeight: "500",
            }}>{total}</span>
          </span>

          <div style={{ width: "1px", height: "18px", background: "#e0e0e8", flexShrink: 0 }} />

          {/* Pipeline selector */}
          <select
            value={pipeline}
            onChange={e => setPipeline(e.target.value)}
            onFocus={focusIn} onBlur={focusOut}
            style={{
              height: "30px", padding: "0 24px 0 8px", border: "1.5px solid #e0e0e8",
              borderRadius: "8px", fontSize: "12.5px", fontWeight: "500", color: "#1a1a2e",
              background: "#f8f8fc", appearance: "none", outline: "none", cursor: "pointer",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5'%3E%3Cpath d='M1 1l3 3 3-3' stroke='%239e9eb8' stroke-width='1.2' stroke-linecap='round' fill='none'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat", backgroundPosition: "right 8px center",
            }}
          >
            {PIPELINES.map(p => <option key={p}>{p}</option>)}
          </select>
        </div>

        {/* RIGHT */}
        <div style={S.row(6)}>

          {/* View toggle */}
          <div style={{ display: "flex", gap: "2px", background: "#f0f0f8", padding: "3px", borderRadius: "8px" }}>
            {[{ v: "kanban", icon: "kanban", title: "Kanban" }, { v: "list", icon: "list", title: "List" }].map(({ v, icon, title }) => (
              <button key={v}
                onClick={() => { setView(v); setActiveTab(v === "kanban" ? "kanban" : "active"); }}
                title={title}
                style={{
                  width: "30px", height: "26px", border: "none", cursor: "pointer",
                  borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center",
                  background: view === v ? "#fff" : "transparent",
                  boxShadow: view === v ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                  color: view === v ? "#1a1a2e" : "#9e9eb8", transition: "all .15s",
                }}>
                <Ic n={icon} s={13} />
              </button>
            ))}
          </div>

          {/* Integrations dropdown */}
          <Dropdown
            right
            trigger={
              <button style={{
                ...S.row(4), height: "30px", padding: "0 11px",
                border: "1.5px solid #e0e0e8", borderRadius: "8px",
                background: "#fff", cursor: "pointer", fontSize: "12.5px",
                fontWeight: "500", color: "#3a3a5c",
              }}>
                Integrations <Ic n="chevDown" s={8} c="#9e9eb8" />
              </button>
            }
            items={[
              { label: "Email",          icon: "mail"     },
              { label: "Social Media",   icon: "user"     },
              { label: "Telephony",      icon: "phone"    },
              { label: "WhatsApp",       icon: "whatsapp" },
              "---",
              { label: "All Integrations", icon: "link"  },
            ]}
          />

          {/* Automation */}
          <button style={{
            ...S.row(5), height: "30px", padding: "0 11px", border: "none",
            borderRadius: "8px", background: "#e8f5e9", color: "#2E7D32",
            cursor: "pointer", fontSize: "12.5px", fontWeight: "600",
          }}>
            <Ic n="automation" s={12} c="#2E7D32" /> Automation
          </button>

          {/* Settings */}
          <button
            title="Module Settings"
            style={{
              width: "30px", height: "30px", border: "1.5px solid #e0e0e8",
              borderRadius: "8px", background: "#fff", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", color: "#8888a8",
            }}>
            <Ic n="settings" s={14} />
          </button>

          {/* More menu */}
          <Dropdown
            right
            trigger={
              <button style={{
                width: "30px", height: "30px", border: "1.5px solid #e0e0e8",
                borderRadius: "8px", background: "#fff", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", color: "#8888a8",
              }}>
                <Ic n="more" s={14} />
              </button>
            }
            items={[
              { label: "Import from CSV",   icon: "import"   },
              { label: "Edit Pipeline",     icon: "pipeline" },
              "---",
              { label: "Module Settings",   icon: "settings" },
            ]}
          />

          {/* Create CTA */}
          <button
            onClick={onCreateNew}
            style={{
              ...S.row(6), height: "32px", padding: "0 16px",
              border: "none", borderRadius: "8px",
              background: "linear-gradient(135deg,#1a1a2e,#0f3460)",
              color: "#fff", cursor: "pointer", fontSize: "13px", fontWeight: "600",
              boxShadow: "0 2px 8px rgba(15,52,96,.22)", transition: "opacity .15s",
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = ".85"}
            onMouseLeave={e => e.currentTarget.style.opacity = "1"}
          >
            <Ic n="plus" s={11} c="white" /> Create
          </button>
        </div>
      </div>

      {/* ── Row 2: Tabs ── */}
      <div style={{
        ...S.row(0), borderTop: "1px solid #f0f0f8",
        padding: "0 20px", height: "38px", justifyContent: "space-between",
      }}>
        <div style={S.row(0)}>
          {view === "kanban"
            ? <BtnTab code="kanban" label="Kanban Board" />
            : listTabs.map(t => <BtnTab key={t.code} code={t.code} label={t.label} />)
          }
        </div>
        <span style={{ fontSize: "11.5px", color: "#b0b0c8" }}>
          {total} {total === 1 ? "opportunity" : "opportunities"}
        </span>
      </div>
    </div>
  );
}
